import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';

@Component({
  standalone: true,
  imports: [MatDialogModule, CommonModule],
  selector: 'app-confirm-dialog',
  template: `
    <h2 mat-dialog-title>{{ data.title }}</h2>
    <mat-dialog-content>{{ data.message }}</mat-dialog-content>
    <mat-dialog-actions align="end">
      <button *ngIf="data.cancelBtn" mat-button (click)="onCancel()" style="padding: .5rem; margin-right: .5rem; cursor: pointer;">{{ data.cancelBtn }}</button>
      <button *ngIf="data.confirmBtn" mat-button color="warn" (click)="onConfirm()" style="padding: .5rem; cursor: pointer;">{{ data.confirmBtn }}</button>
    </mat-dialog-actions>
  `,
})
export class ConfirmDialogComponent {
  constructor(
    private dialogRef: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { title: string; message: string; cancelBtn: string; confirmBtn: string }
  ) {}

  onConfirm() {
    this.dialogRef.close(true);
  }

  onCancel() {
    this.dialogRef.close(false);
  }
}